var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"title-line"},[_c('span',{staticClass:"index-num"},[_vm._v(_vm._s(_vm.num))]),_c('span',{staticClass:"title-text"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"split-line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }